import React, { createContext, useContext } from 'react';
import { useSupabaseAuth } from '../hooks/useSupabaseAuth';
import { isNativePlatform } from '../utils/nativeUtils';

const MobileAuthContext = createContext();

export const useMobileAuth = () => {
    const context = useContext(MobileAuthContext);
    if (!context) {
        throw new Error('useMobileAuth must be used within a MobileAuthProvider');
    }
    return context;
};

export const MobileAuthProvider = ({ children }) => {
    // Reuse the existing Supabase auth logic
    // In a real native app, we might need specific handling for OAuth redirects (using deep links)
    // but Capacitor often handles this if configured correctly.
    // For now, we wrap the standard web auth.
    const auth = useSupabaseAuth();

    const isNative = isNativePlatform();

    const value = {
        ...auth,
        isNative,
        // Add any mobile-specific auth methods here if needed later
        // e.g. biometric login wrappers
    };

    return (
        <MobileAuthContext.Provider value={value}>
            {children}
        </MobileAuthContext.Provider>
    );
};
